module.exports = "/build/admin/images/apple-touch-icon-152x152.e2ccc39b.png";